export default function getFeaturedIcon(featureList) {
  return featureList?.filter((feature) => Boolean(feature?.featured))[0];
}
